import { render } from "./Map-Clientes.vue?vue&type=template&id=dd53987c&scoped=true"
import script from "./Map-Clientes.vue?vue&type=script&lang=js"
export * from "./Map-Clientes.vue?vue&type=script&lang=js"

import "./Map-Clientes.vue?vue&type=style&index=0&id=dd53987c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd53987c"]])

export default __exports__